import {useEffect, useState} from "react";

export const useFormIsValid = (isValid) => {
    const [submitEnabled, setSubmitEnabled] = useState(false);

    useEffect(() => {
        setSubmitEnabled(isValid);
    }, [isValid])

    return {submitEnabled, setSubmitEnabled};
}